import axiosClient from "./axiosClient";

export async function getStoreCoupons(storeId) {
  const response = await axiosClient.get(`/Coupons/store/${storeId}`);
  return response.data;
}

export async function fetchMyCoupons() {
  const response = await axiosClient.get("/ClientCoupons/mine");
  return response.data;
}

export async function validateCoupon(payload) {
  const response = await axiosClient.post("/coupons/validate", payload);
  return response.data;
}

// Platform-wide coupons created by an admin aren't tied to a single store,
// so they're validated separately from the per-store coupons above.
export async function validateClientCoupon(payload) {
  const response = await axiosClient.post("/ClientCoupons/validate", payload);
  return response.data;
}
